<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">
        {{ $t("Cashier Revenue Report") }}
      </div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-4 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                  @selected="onChangeDate($event, 'from')"
                  :disabled-dates="disabledDates"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="toDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                  :disabledDates="{
                    from: new Date(
                      moment(fromDate).add(31, 'd').format('YYYY-MM-DD')
                    ),
                  }"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }}  -->
                  {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getRdrExceptionReport({isPdf:'N',isExcel:'N'})"
            >
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>

          <div
            v-if="rdrExceptionRecords.length > 0"
            class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
          >
            <div class="mx-1">{{ $t("download") }} as:</div>
            <!-- s -->
            <span
              @click="getRdrExceptionReport({isPdf:'Y',isExcel:'N'})"
              style="cursor: pointer"
              title="Download as Pdf"
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/pdf.svg"
                height="25"
                width="25"
              />
            </span>
            <span
              @click="getRdrExceptionReport({isPdf:'N',isExcel:'Y'})"
              style="cursor: pointer"
              title="Download as Excel"
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
              />
            </span>
          </div>
        </div>
      </div>
      <div
        style="overflow-x: scroll; width: auto !important"
        ref="exportable_table"
      >
        <table class="swc-report-table" border="1">
          <tr class="bg-lightgrey font-weight-bold">
            <!-- <th>Outlet</th> -->
            <th>Hardware Name</th>
            <th>Unit Name</th>
            <th>Shift Id</th>
            <th>Business Date</th>
            <th>Shift Login Time</th>
            <th>Shift Logout Time</th>
            <th>Shift Number</th>
            <th>User Name</th>
            <th>User</th>
            <th>Packet Data</th>
            <th>Payment Type</th>
            <th>Pos Transaction Amount</th>
            <!-- <th>User RDR Drop Amount</th> -->
            <th>TL RDR Drop Amount</th>
            <th>Difference</th>
            <th>TL Name</th>
          </tr>
          <tbody v-if="rdrExceptionRecords.length > 0">
            <tr
              v-for="(
                rdrExceptionData, rdrExceptionDataIndex
              ) in rdrExceptionRecords"
              :key="rdrExceptionDataIndex"
            >
              <!-- <td class="text-left">
                {{ rdrExceptionData.outlet || "Box-Office" }}
              </td> -->
              <td class="text-left">
                {{
                  rdrExceptionData.hardware_name
                    ? rdrExceptionData.hardware_name
                    : "-"
                }}
              </td>
              <td class="text-left">{{ rdrExceptionData.cine_name }}</td>

              <td class="text-left">S{{ rdrExceptionData.usl_id }}</td>
              <td class="text-left">{{ rdrExceptionData.shift_end_date }}</td>
              <td class="text-left">{{ rdrExceptionData.login_date_time }}</td>
              <td class="text-left">{{ rdrExceptionData.logout_date_time }}</td>
              <td class="text-right">
                {{ rdrExceptionData.shift_number || "-" }}
              </td>
              <td class="text-left">
                {{ rdrExceptionData.user_shift_name || "-" }}
              </td>
              <td class="text-left">
                {{ rdrExceptionData.user_employee_code || "-" }}
              </td>
              <td class="text-left">Packet-1</td>
              <td class="text-left">
                {{ rdrExceptionData.pm_payment_mode || "-" }}
              </td>
              <td class="text-right">
                {{
                  rdrExceptionData.scs_system_recorded_amount
                    ? currFormat(rdrExceptionData.scs_system_recorded_amount)
                    : "0.00"
                }}
              </td>
              <td class="text-right">
                {{
                  rdrExceptionData.scs_user_recorded_amount
                    ? currFormat(rdrExceptionData.scs_user_recorded_amount)
                    : "0.00"
                }}
              </td>
              <!-- <td class="text-right">
                {{
                  rdrExceptionData.tl_collection_amount
                    ? currFormat(rdrExceptionData.tl_collection_amount)
                    : "0.00"
                }}
              </td> -->
              <td
                :class="
                  rdrExceptionData.scs_user_recorded_amount -
                    rdrExceptionData.scs_system_recorded_amount >
                  0
                    ? 'text-right text-success'
                    : rdrExceptionData.scs_user_recorded_amount -
                        rdrExceptionData.scs_system_recorded_amount <
                      0
                    ? 'text-right text-danger'
                    : 'text-right'
                "
              >
                {{
                  currFormat(
                    rdrExceptionData.scs_user_recorded_amount -
                      rdrExceptionData.scs_system_recorded_amount
                  )
                }}
              </td>
              <td class="text-left">
                {{rdrExceptionData.modifiedBy || "-"}}
              </td>
            </tr>
            <tr class="bg-lightgrey">
              <td colspan="11" class="text-left">Grand Total</td>
              <td class="text-right">
                {{
                   currFormat(
                    grandTotal.total_system_recorded_amount
                  )
                }}
              </td>
              <td class="text-right">
                {{
                   currFormat(
                    grandTotal.total_user_recorded_amount
                  )
                }}
              </td>
              <td>-</td>
              <td>-</td>

            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="11">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="swc-report" v-if="rdrExceptionRecords.length == 0"></div>
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/ReportsService-v2";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";
import * as XLSX from "xlsx";

export default {
  components: {
    NoRecords,
    VueHtml2pdf,
  },
  data() {
    return {
      BASEURL,
      isRoleID: false,
      submitted: false,
      grandTotal:{},
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      fromDate: moment().toDate(),
      toDate: new Date(),
      rdrExceptionRecords: [],
      excelFilePath: "",
      disabledDates: {
        from: new Date(),
      },
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
    // if (CinemaObj) {
    //   this.onSelectCinema(CinemaObj);
    // }
  },
  watch: {
    // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
    //   if (CinemaObj) {
    //     this.onSelectCinema(CinemaObj);
    //   }
    // },
    excelFilePath(value) {
      this.excelFilePath = value;
    },
  },
  mounted() {},
  methods: {
    onChangeDate(e, type) {
      console.log("onChangeDate", type);
      if (type == "from") {
        this.toDate = new Date(e);
        this.$forceUpdate();
      }
    },
    moment,
    ExportExcel(type, fn, dl) {
      var elt = this.$refs.exportable_table;
      var wb = XLSX.utils.table_to_book(elt, {
        sheet: `RawMaterialSupplierWise`,
      });
      return dl
        ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
        : XLSX.writeFile(
            wb,
            fn ||
              `RawMaterialSupplierWiseCost-${
                this.dropDown.selectedCinemaName
              }.${type || "xlsx"}`
          );
    },
    getCinemaList: function () {
      MasterService.GetCinemasByRoles()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            let Cinemas = [
              {
                cine_id: "all",
                cine_name: "All Cinema",
              },
            ];
            this.dropDown.cinemas = [...Cinemas, ...data.Records];
            this.CinemasCopy = [...Cinemas, ...data.Records];
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      if (event.cine_name != "all") {
        this.$store.dispatch("selectDropdownCinema", event);
      }
    },
    getRdrExceptionReport({isPdf="N",isExcel="N"}) {
      this.rdrExceptionRecords = [];
      if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      }
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }
      let loader = this.$loading.show();
      let payload = {
        cinema_id: this.dropDown.selectedCinemaId,
        cinema_name: this.dropDown.selectedCinemaName || "",
        cinema_address:
          this.dropDown.selectedCinemaId != "all"
            ? this.dropDown.selectedCinema.cine_address
            : "",
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        excel: isExcel,
        isPdf
      };
      ReportsService.GetRdrException(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.rdrExceptionRecords = [...data.Records];
            this.grandTotal=data.grandTotal
            if (isExcel == "Y" && data.excelPath) {
              window.open(data.excelPath, "_blank");
            } 
            else if(isPdf=="Y" && data.pdfPath){
              window.open(data.pdfPath, "_blank");
            }           
            else {
              this.$toasted.show(data.message);
            }
          } else {
            this.$toasted.show(data.message);
          }
          loader.hide();
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 100);
        });
    },
  },
};
</script>

<style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}
.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  overflow-x: scroll !important;
  border: 1px solid black;
}
.swc-report-table td {
  white-space: nowrap;
}
.swc-report-table th {
  white-space: nowrap !important;
  border: 1px solid black !important;
}
.swc_table_header th {
  border: 1px solid black !important;
}
.no_border {
  border: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/rdrExceptionReport.vue